import {initPicksInArea} from "@/utils/area";
import {jointContexts, pickIsSearch} from "@/utils/pick";

const mutations = {
    pickCreate: (state, payload) => {
        console.log("MUTATION pick/create", payload);

        // after creation - call this
        payload.mutation = "pickAppend";

        // after creation - broadcast to subscribers of this
        const broadcast = [{
            entity: "context",
            auth: payload.contextId,
        }];
        payload.broadcast = broadcast;
        console.log("broadcast", broadcast);
    },
    pickFrom: (state, payload) => {
        console.log("MUTATION pick/from", payload);

        // after creation - call this
        payload.mutation = "pickAppend";

        const area = state.session.area;
        let items = jointContexts(area);
        const existing = items.find(el=>el.contextId === payload.contextId);
        if ( pickIsSearch(existing) ) {
            // for new search pick we just remove isSearch
            existing.preset = null;

        }

        // after creation - broadcast to subscribers of this
        const broadcast = [{
            entity: "context",
            auth: payload.contextId,
        }];
        payload.broadcast = broadcast;
        console.log("broadcast", broadcast);
    },
    pickAppend: (state, payload) => {
        console.log("MUTATION pick/append", payload);
        return;

        // TODO review

        const item = payload?.pickAppend?.item;
        if (!item) return;

        const area = state.session.area;
        let items = area.picks;

        // append item
        if (!items) {
            console.log("NEW PICKS");
            initPicksInArea(area);
            area.picks.push(item);
        }
        else if (items?.findIndex(el => el.id === item.id) === -1) {
            //console.log("NEW PICK!", item);
            items.push(item);
            initPicksInArea(area);
            console.log("APPENDED PICK", item);
        }
    },
};

export default mutations;
